module.exports = __webpack_public_path__ + "img/logo-mp.93232f92.png";